module.exports = __webpack_public_path__ + "media/feature-icons/Reference_Data-240312a2.svg";